module.exports = __webpack_public_path__ + "static/img/pic-2.742287f4.png";